// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smJRaB8Y3X1jMc {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.iIAoBI7jRJ6eOP {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.rNMrkex9nBnCM5 {
  padding: var(--ds-space-400, 32px) var(--ds-space-500, 40px) var(--ds-space-500, 40px);
  text-align: center;
}
.gwstozkT26SYCz {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.q3uC0GP7BlOQLr {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.q3uC0GP7BlOQLr:hover,
.q3uC0GP7BlOQLr:active {
  color: #ffffff;
}
`, ""]);
// Exports
export var gaAnnouncementModal = `smJRaB8Y3X1jMc`;
export var headingImage = `iIAoBI7jRJ6eOP`;
export var contentContainer = `rNMrkex9nBnCM5`;
export var ctasContainer = `gwstozkT26SYCz`;
export var closeButton = `q3uC0GP7BlOQLr`;
export default ___CSS_LOADER_EXPORT___;
